"use client"
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Datepicker as JopiDatePicker,
  Text,
} from '@quintoandar-tokko/jopijs'
import { setCalendarData } from '@/store/slices/components/calendar/CalendarSlice';
import TimeSelector from '../timeSelector/TimeSelector'
import DatePickerSkeleton from './DatepickerSkeleton';
import CalendarTimezoneDropdown from '../CalendarTimezoneDropdown/CalendarTimezoneDropdown';
import {
  getDayHours,
  getMonthAvailableDays,
} from '@/store/slices/components/calendar/services';
import { getLocale } from '../utils/dates';
import Trans from '@/components/shared/Trans'
import translations from './datepicker.trans.json'
import style from './datepicker.module.scss'

export default function DatePicker () {
  const calendar = useSelector(state => state.CalendarSlice)
  const dispatch = useDispatch()
  const twoDaysFromNow = new Date(Date.now() + 2 * 24 * 60 * 60 * 1000)
  const locale = getLocale()

  const handleDayChange = (date) => {
    if (calendar.schedule.loadingHours) return
    
    const { host } = calendar
    const propertyId = calendar.property.id
    const dateFrom = new Date(date).toISOString().split('T')[0]
    const dateSelected = dateFrom
    const { gmt } = calendar.property

    dispatch(setCalendarData({ key: 'visit', subkey: 'date', value: date }))
    dispatch(getDayHours({ propertyId, dateFrom, dateSelected, gmt, host }))

    // Smooth scroll to bottom on mobile devices (< 992px)
    if (window.innerWidth < 992) {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      })
    }
  }

  const handleMonthChange = (date) => {
    const { host } = calendar
    const propertyId = calendar.property.id
    const dateFrom = new Date(date).toISOString().split('T')[0]
    const { gmt } = calendar.property

    dispatch(getMonthAvailableDays({ propertyId, dateFrom, gmt, host }))
  }

  const isAvailableDay = (date) => {
    const day = date.getDate()
    return calendar.schedule.availableDays.includes(day)
  }

  const isCurrentDay = (date) => {
    const today = new Date();
    return date.toDateString() === today.toDateString();
  };

  const getDayClassName = (date) => {
    if (isCurrentDay(date)) {
      return 'datepicker-today-highlight';
    }
  };

  return (
    <Box
      as="section"
      className={style.datepickerContainer}
      data-loading-month={calendar.schedule.loadingMonth}
    >
      <Text className={style.datepickerTitle}>
        {Trans(translations, 'SelectADayAndATime')}
      </Text>

      <CalendarTimezoneDropdown />

      <Box className={style.datepickerAndTimeSelectorWrapper}>
        {calendar.schedule.loadingMonth && (
          <DatePickerSkeleton __css={{ position: 'absolute' }} />
        )}
        <JopiDatePicker
          inline
          minDate={twoDaysFromNow}
          selected={calendar.visit.date ? new Date(calendar.visit.date) : null}
          onChange={handleDayChange}
          locale={locale}
          filterDate={isAvailableDay}
          dayClassName={getDayClassName}
          onMonthChange={handleMonthChange}
        />
        <TimeSelector />
      </Box>
    </Box>
  )
}
